import React from 'react';

import fetch from '../fetch';

import utils from '../../utils';

import {Modal, Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {key:'targetName', label: '诊改指标'},
    {key:'resultScore', label: '录入总分'},
    {key:'submitEmployeeName', label: '录入人'},
    {key:'orgResultState', label: '状态',render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>待提交</Tag>)},
    {key:'resultDesc', label: '结果描述'}
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
])

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    
    return fetch.post('zgcp/subresult/queryByResultId?'+ params.join('&'), Object.assign({
        type: "view"
    }, defaultsParams, newKeyword))
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = [] 
        if(extParams) {
            for(let i = 0; i < columnsArray.length; i++) {
                newArray.push(columnsArray[i])
                if(i === 2) {
                    if(extParams.options.length > 0){
                        extParams.options.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value
                            })
                        })
                    }
                }
            }
        }
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(newArray.length > 0 ? newArray :columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: res.data.dataList || [],
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('zgcp/subresult/get/'+ id, {})
    .then(response => {
        return response;
    });
}

const updateResult = (data) => {
    return fetch.post('zgcp/subresult/update', data);
}

/**
 * @method querySearchBySubId
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearchBySubId = (keywords) => {
    return fetch.get('jszgsubresult/getItemBySubId/'+ keywords.subId+'_'+keywords.resultId, {})
    .then(response => {
        return response;
    });
}

/**
 * @method querySearchByRowId
 * @param {number} id
 * @return {promise}
 */
const querySearchByRowId = (id) => {
    return fetch.get('jszgsubresult/getItemByRowId/'+ id, {})
    .then(response => {
        return response;
    });
}

/**
 * @method removeFileByRowId
 * @param {object} [keywords]
 * @return {promise}
 */
const removeFileByRowId = (fileId,rowIndex,subId,subResultId) => {
    return fetch.post('jszgfile/removeFileByRowId/', {fileId,rowIndex,subId,subResultId})
    .then(response => {
        return response.payload.data;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('zgcp/subresult/remove', ids)
    .then(response => {
        return response;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections)
                .then(response => {
                    if(response.code === 200) {
                        Modal.success({
                            title: '提示信息',
                            content: (
                                <div>
                                <p>{response.message}</p>
                                </div>
                            ),
                            okText:"确认",
                            onOk() {
                                callback();
                            },
                        })
                    }
                    ;
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'jszgsubresult'+ url;
};

export default {
    querySearch,
    querySearchById,
    updateResult,
    download: fetch.base + 'zgcp/enter/file/download?id=',
    onlyDownload: fetch.base + 'zgcp/enter/file/onlyDownload?id=',
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    getSelection,
    querySearchByRowId,
    querySearchBySubId,
    removeFileByRowId,
}
